import { AddressDto} from './AddressDto';

export class IntermediaryDto {
  organisationId: string;
  organisationName: string;
  telephone: string;
  email: string;
  subagentId: number;
  address: AddressDto;
}
